import { connect } from "react-redux";
import Modal from "../../shared/components/modal";
import { formatTimeTxt } from "../../../services/helpers/Helper";
import { deleteCommentPost } from "../../../store/action/commentPostAction";

const ListPostComment = (props) => {
   const { onClose, commentPosts, deleteCommentPost } = props;
   return (
      <Modal>
         <div className="modal-dialog app-modal app-v2-modal popup-add-product-custom modal-lg" role="document">
            <div className="modal-content">
               <div className="app-modal-header">
                  <h4 className="app-modal-title">
                     <div className="app-v2-modal-header">
                        <div className="custom">
                           <div className="display-flex">
                              <span>Danh sách bình luận</span>
                           </div>
                        </div>
                        <div className="icon-wrapper" onClick={onClose}>
                           <span className="icon-close app-close">
                              <div className="svg-next-icon ic-modal-close" >
                              </div>
                           </span>
                        </div>
                     </div>
                  </h4>
               </div>
               <div className="app-modal-body" style={{ overflow: 'auto' }}>
                  <div className="table-container flex-1 flex-display-col w100">
                     <table className="app-table app-table--vertical-middle">
                        <thead style={{ height: 50 }}>
                           <tr>
                              <th style={{ width: 100, textAlign: 'center' }}><span>Id</span></th>
                              <th style={{ textAlign: 'center' }}><span>Nội dung</span></th>
                              <th style={{ width: 100, textAlign: 'center' }}><span>Thời gian bình luận</span></th>
                              <th style={{ width: 100, textAlign: 'center' }}><span>Hành động</span></th>
                           </tr>
                        </thead>
                        <tbody>
                           {commentPosts.map((item, index) => {
                              return (
                                 <tr className="app-v2-table-row" key={index} style={{ height: 40 }}>
                                    <td style={{ width: 110 }}>
                                       <div className="status-feed-drafts">{item.id}</div>
                                    </td>
                                    <td >
                                       <div className="status-feed-drafts" style={{ whiteSpace: 'pre-line' }}>{item.message}</div>
                                    </td>
                                    <td style={{ width: 110 }}>
                                       <span> {formatTimeTxt(item.comment_time)}</span>
                                    </td>
                                    <td style={{ width: 100, textAlign: 'center' }}>
                                       <div>
                                          <a className="hover-alert icon-delete pointer text-note" onClick={() => deleteCommentPost(item.id)}>
                                             <div className="svg-next-icon ic-trash">
                                             </div>
                                          </a>
                                       </div>
                                    </td>
                                 </tr>
                              )
                           })}
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </Modal>
   )
}

const mapStateToProps = (state) => {
   const { commentPosts } = state;
   return {
      commentPosts
   };
};

export default connect(mapStateToProps, {
   deleteCommentPost
})(ListPostComment);
